import React from "react";
import { HeaderModule } from '../../../components/home/HeaderModule';
import { ArticleOutlined } from "@mui/icons-material";
import { ActionsBar } from "../../../components/ActionsBar";
import { TableModule } from "../../../components/home/TableModule";
import { useSurveys } from "../../../hooks/encuestas/useSurveys";

export const Surveys = () => {

    const { columns, surveys, addSurvey, searchSurvey } = useSurveys();

    return (
        <>
            <HeaderModule 
                icon={ <ArticleOutlined htmlColor="rgba(0, 0, 0, .6)" /> }
                title='Encuestas'
            />

            <ActionsBar 
                addAction={ addSurvey }
                module='encuestas'
                searchAction={ searchSurvey } 
                searchPlaceholder='Código' 
            />

            <TableModule
                columns={ columns }
                rows={ surveys }
                styles={{
                    background: '#fff',
                    borderRadius: 6,
                    marginTop: 10,
                }}
            />
        </>
    )
};